import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";

function isValidIANATimeZone(tz) {
  try {
    Intl.DateTimeFormat(undefined, { timeZone: tz });
    return true;
  } catch {
    return false;
  }
}

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [timezone, setTimezone] = useState("");
  const [location, setLocation] = useState("");

  async function handleLogin(e) {
    e.preventDefault();

    if (email && password && timezone && location) {
      if (!isValidIANATimeZone(timezone)) {
        alert("Please enter the correct IANA time zone.");
        return
      }

      try {
        const response = await fetch("https://ai.ziea.net/api/login", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email,
            password: password,
            timezone: timezone,
            location: location,
          }),
        });

        if (!response.ok) {
          const errorText = await response.text();
          alert("Please enter the correct user information, status=" + response.status + ":" + errorText);
          return
        }

        const res = await response.json();

        navigate("/chat", {
          state: {
            user_timezone: timezone,
            user_location: location,
            auth_result: res.auth,
          },
        })
      } catch (err) {
        alert("Please enter the correct user information.");
      }
    } else {
      alert("Please enter your user information.");
    }
  }

  return (
    <div className="login-container">
      <form className="login-box" onSubmit={handleLogin}>
        <h2>ZIEA User</h2>
        <input
          type="text"
          placeholder="Username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <input
          type="text"
          placeholder="TimeZone (Asia/Shanghai)"
          value={timezone}
          onChange={(e) => setTimezone(e.target.value)}
        />
        <input
          type="text"
          placeholder="Location (SanmenRoad, Shanghai)"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
        />
        <button type="submit">Login</button>
      </form>
    </div>
  );
}